import React from "react"
import PropTypes from "prop-types"
import _ from "lodash"
import { getMessage } from "@/utils/MessageUtils"

class ProgressStatus extends React.Component {
  static propTypes = {
    progressStatus: PropTypes.string,
  }

  render() {
    const { progressStatus } = this.props
    if (!progressStatus) {
      return null
    }
    return <span>{getMessage(progressStatus, "ProgressStatus")}</span>
  }
}

export default ProgressStatus
